module.exports = function UpdateSourceUpdateResponse(error) {
    this.error = error;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update-response.js
// module id = 303
// module chunks = 1